module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0099.jpg?v=907ac627";